// extracted by mini-css-extract-plugin
export default {"root":"BottomTab_root__XxHk7","tabItem":"BottomTab_tabItem__kVkFL","currentTab":"BottomTab_currentTab__BnUFV","tabText":"BottomTab_tabText__c8NY2"};